import { useParams } from 'react-router-dom'
import { Container, LoadingOverlay, Paper } from '@mantine/core'

import { EventTitle } from '@/components/common/EventTitle'
import { EventDetail } from '@/components/Event/CourtReporterDetail/EventDetail'
import { Shell } from '@/components/Shell'
import { useAdminCourtReporterEventQuery } from '@/queries/courtReporters'
import { EventLoadError } from '@/routes/Event/components/EventLoadError'
import { NotFound } from '@/routes/NotFound'

export const Event = () => {
  const { id } = useParams<{ id: string }>()

  const {
    data: event,
    isLoading,
    isFetching,
    refetch,
    error,
  } = useAdminCourtReporterEventQuery(id, {
    refetchInterval: 20000,
    refetchOnWindowFocus: true,
  })

  if (isLoading) {
    return (
      <Shell>
        <LoadingOverlay visible={true} />
      </Shell>
    )
  }

  if (event === undefined) {
    if (error?.response?.status === 404) {
      return <NotFound text="Event not found" />
    }

    return (
      <EventLoadError
        onRetry={() => {
          void refetch()
        }}
        isFetching={isFetching}
      />
    )
  }

  return (
    <Shell header={{ middle: <EventTitle>{event.name}</EventTitle> }}>
      <Container size="lg">
        <Paper p="xl">
          <EventDetail event={event} isAdmin />
        </Paper>
      </Container>
    </Shell>
  )
}
